// Optimistic accolade verify toggle. Mirrors useMeasurableSaves.toggleVerify's
// optimistic-set + revert-on-error, but hits the per-accolade-id endpoint
// (POST /athletes/{userId}/accolades/{id}/verify) which returns the updated row.
import { useState } from 'react';
import axios from 'axios';

export default function useAccoladeVerify({ userId, apiUrl, getConfig, setAccolades }) {
  const [busyId, setBusyId] = useState(null);

  const toggleVerify = async (a) => {
    const next = !a.verified;
    setBusyId(a.id);
    setAccolades(list => list.map(x => (x.id === a.id ? { ...x, verified: next } : x)));
    try {
      const res = await axios.post(
        `${apiUrl}/athletes/${userId}/accolades/${a.id}/verify`, {}, getConfig());
      setAccolades(list => list.map(x => (x.id === a.id ? res.data : x)));
    } catch {
      // revert
      setAccolades(list => list.map(x => (x.id === a.id ? { ...x, verified: a.verified } : x)));
    } finally {
      setBusyId(null);
    }
  };

  return { toggleVerify, busyId };
}
